<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-09-07 11:04:09
 * @LastEditors: Please set LastEditors
 -->
<template>
     <div class="container">
          <el-tabs v-model="active" type="card" @tab-click="handleIsparent">
              <el-tab-pane label="直属门店订单" name="1">
                     <el-tabs v-model="status" type="card" @tab-click="handleClick">
            <el-tab-pane :label="all" name=" " >
            </el-tab-pane>
            
            <el-tab-pane  :label="JSON.stringify(count[6])  | filte" :name="JSON.stringify(count[6].status)">
            </el-tab-pane>
            <el-tab-pane  :label="JSON.stringify(count[7]) | filte" :name="JSON.stringify(count[7].status)">
            </el-tab-pane>
            <el-tab-pane :label="JSON.stringify(count[1]) | filte"  :name="JSON.stringify(count[1].status)">
            </el-tab-pane>
            <el-tab-pane  :label="JSON.stringify(count[0]) | filte" :name="JSON.stringify(count[0].status)">
            </el-tab-pane>
            <el-tab-pane   :label="JSON.stringify(count[5])  | filte"  :name="JSON.stringify(count[5].status)">
            </el-tab-pane>
            <el-tab-pane  :label="JSON.stringify(count[4]) | filte" :name="JSON.stringify(count[4].status)">
            </el-tab-pane>
            <el-tab-pane   :label="JSON.stringify(count[2])  | filte" :name="JSON.stringify(count[2].status)">
            </el-tab-pane>
            <el-tab-pane   :label="JSON.stringify(count[3])  | filte" :name="JSON.stringify(count[3].status)">
            </el-tab-pane>
        </el-tabs>
         
                <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                     <el-form-item label="下单时间" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form1.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form1.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
                    
                    <el-form-item >
                        <el-select v-model="form1.key_type">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="订单号" value="1"></el-option>
                            <el-option label="产品编号" value="2"></el-option>
                            <el-option label="产品名称" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                 <el-form-item >
                        <el-input v-model="form1.keywords" clearable ></el-input>
                    </el-form-item>


                     <el-form-item label='支付方式'>
                        <el-select v-model="form1.pay_type">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="线下支付" value="1"></el-option>
                            <el-option label="微信支付" value="2"></el-option>
                            <el-option label="微信扫码支付" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                   
                    <el-form-item label="是否赠品:">
                        <el-select v-model="form1.isgift">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="赠品" value="1"></el-option>
                            <el-option label="非赠品" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                        <el-form-item label="门店:">
                <el-col :span="12">
                    <el-input v-model="form1.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 10px;">
                    <el-button type="primary" @click="selectType()">选择</el-button>
                </el-col>
            </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList()">搜索</el-button>
                        <el-button type="primary" @click="exportList(form1)">导出</el-button>
                    </el-form-item>
                </el-form>
                <div style='margin-bottom:10px;'>订单总金额: <span class='red'>￥{{allMoney}} </span> </div>

               <div class="tableBox" v-loading="loading" style="width: 100%;margin-bottom: 20px; overflow:auto">
                <el-table
                  :data="tableData1"
                  style="width: 100%;margin-bottom: 20px"
                  border
                  fit
                  v-loading='loading'
                  max-height="500"
                  >
                  <!-- <el-table-column prop="id" label="序号" sortable fixed="left">
                    <template slot-scope="scope">
                      {{scope.row.id }}
                    </template>
                  </el-table-column> -->
                  <el-table-column prop="stock_out_sn" label="订单号" fixed="left" width="180"></el-table-column>
                  <el-table-column prop="to_name" fixed="left" label="订货门店名称" width="180"></el-table-column>
                  <el-table-column prop="to_sn" label="订货门店编号"  width="180"></el-table-column>
                  <el-table-column prop="to_level_name" label="所属经销商编号" width="180"></el-table-column>
                  <el-table-column prop="from_superior_sn" width="180" label="所属经销商级别"></el-table-column>
                  <el-table-column prop="total_stock_out_num" width="180" label="订单金额">
                    <template slot-scope="scope">
                      {{scope.row.total_price | filMoney}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="total_stock_out_num" label="支付方式">
                    <template slot-scope="scope">
                      <span v-if="scope.row.pay_type == 1">线下支付</span>
                      <span v-if="scope.row.pay_type == 2">微信支付</span>
                      <span v-if="scope.row.pay_type == 3">微信扫码支付</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop label="是否赠品" width="180">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isgift == 1">赠品</span>
                      <span v-else>非赠品</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="to_address" label="收货地址"  width="180"></el-table-column>
                  <el-table-column prop="created_at" label="下单时间"  width="180"></el-table-column>
                  <el-table-column prop="order_notes" label="订单留言"  width="180"></el-table-column>
                  <el-table-column prop="product_sn" label="产品编号"  width="180"></el-table-column>
                  <el-table-column prop="product_name" label="产品名称" width="180">
                  </el-table-column>
                  <el-table-column prop="stock_out_num" label="下单数量" width="180">
                  </el-table-column>
                  <el-table-column prop="real_stock_out_num" label="实发数量">
                  </el-table-column>
                  <el-table-column prop="expiring_date" fixed="right"  label="状态">
                    <template slot-scope="scope">
                              <span v-if="scope.row.status == 0">未发货</span>
                              <span v-if="scope.row.status == 1">待收货</span>
                              <span v-if="scope.row.status == 2">发货中</span>
                              <span v-if="scope.row.status == 3">待付款</span>
                              <span v-if="scope.row.status == 4">待审核</span>
                              <span v-if="scope.row.status == 5">审核不通过</span>
                              <span v-if="scope.row.status == 6">已完成</span>
                              <span v-if="scope.row.status == 7">已取消</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="操作" fixed="right" width="180">
                    <template slot-scope="scope">
                        <!-- 0未发货 1已发货 2 部分发货 -->
                               <el-button type="text" size="small" @click='detail(scope.row)' v-if='scope.row.status!==4'>查看详情</el-button>
                                <el-button type="text" size="small"  @click='cancel(scope.row)' v-if='scope.row.status==0'>取消订单</el-button>
                                <el-button type="text" size="small"  @click='inAdvance(scope.row,0)' v-if='scope.row.status==1'>撤销结单</el-button>
                                <el-button type="text" size="small" @click='inAdvance(scope.row,1)' v-if='scope.row.status==2'>提前结单</el-button>
                                <el-button type="text" size="small" @click='review(scope.row,1)' v-if='scope.row.status==4'>审核订单</el-button>
                    </template>
                  </el-table-column>
                </el-table>



            <!-- <table class="table table-striped table-bordered table-hover">
                <thead>
                <tr>
                    <th style="width: 40px;">序号</th>
                    <th style="width: 140px">订单号</th>
                    <th style="width: 120px">日期</th>
                    <th style="width: 240px">订货门店编号</th>
                    <th style="width: 220px">订货门店名称</th>
                    <th style="width: 220px">门店类型</th>
                    <th style="width: 120px">是否赠品</th>
                    <th style="width: 120px">订单金额</th>
                    <th style="width: 120px">支付方式</th>
                    <th style="width: 180px">收货地址</th>
                
                    <th style="width: 160px">订单留言</th>
                    <th style="width: 160px">产品编号</th>
                    <th style="width: 180px">产品名称</th>
                    <th style="width: 180px">下单数量</th>
                    <th style="width: 180px">实发数量</th>

                    <th style="width: 100px;">状态</th>
                    <th style="width: 200px;">操作</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item,index) in tableData1" >
                    <template v-for="(val,num) in item.products">
                        <tr>
                            <template v-if="item.products.length > 0 && num > 0">
                                <td colspan="11"></td>
                            </template>
                            <template v-else>
                                <td style="white-space: nowrap;"> {{(pageSize*(pageNo-1))+index}}</td>
                                <td style="white-space: nowrap;">{{item.stock_out_sn}}</td>
                                <td style="white-space: nowrap;">{{item.created_at}}</td>
                                <td style="white-space: nowrap;">{{item.to_sn}}</td>
                                <td style="white-space: nowrap;">{{item.to_name}}</td>
                                <td style="white-space: nowrap;">{{item.to_level_name}}</td>
                                <td>
                                    <span v-if="item.isgift == 1">赠品</span>
                                    <span v-else>非赠品</span>
                                </td>
                                <td style="white-space: nowrap;">{{item.total_price}}</td>
                                <td style="white-space: nowrap;">
                                      <span v-if="item.pay_type == 1">线下支付</span>
                                    <span v-else>微信支付</span>
                                </td>
                                     <td style="white-space: nowrap;">{{item.to_address}}</td>
                            <td style="white-space: nowrap;">{{item.order_notes}}</td>
                            </template>
                            <td style="white-space: nowrap;">{{val.product_sn}}</td>
                            <td style="white-space: nowrap;">{{val.product_name}}</td>
                            <td style="white-space: nowrap;">{{val.stock_out_num}}</td>

                            <td style="white-space: nowrap;">{{val.real_stock_out_num}}</td>
                            <td style="white-space: nowrap;">
                                <span v-if="val.status == 0">未发货</span>
                                <span v-if="val.status == 1">待收货</span>
                                <span v-if="val.status == 2">部分发货</span>
                                <span v-if="val.status == 3">待付款</span>
                                <span v-if="val.status == 4">待审核</span>
                                <span v-if="val.status == 5">审核不通过</span>
                                <span v-if="val.status == 6">已完成</span>
                                <span v-if="val.status == 7">已取消</span>

                            </td>
                            <td style="white-space: nowrap;">
                                  <el-button type="text" size="small" @click='detail(item.stock_out_sn)' v-if='val.status!==4'>查看详情</el-button>
                                <el-button type="text" size="small"  @click='cancel(item.stock_out_sn)' v-if='val.status==0'>取消订单</el-button>
                                <el-button type="text" size="small"  @click='inAdvance(item.stock_out_sn,0)' v-if='val.status==1'>撤销结单</el-button>
                                <el-button type="text" size="small" @click='inAdvance(item.stock_out_sn,1)' v-if='val.status==2'>提前结单</el-button>
                                <el-button type="text" size="small" @click='review(item.stock_out_sn,1)' v-if='val.status==4'>审核订单</el-button>

                            </td>
                        </tr>
                    </template>
                </template>

                </tbody>
            </table> -->
        </div>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNo"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="非直属门店订单" name="2">
                <!-- @tab-click="" -->
              <el-tabs v-model="status" type="card" @tab-click="handleClick">
            <el-tab-pane :label="all" name="  " >
            </el-tab-pane>
            
            <el-tab-pane  :label="JSON.stringify(count[3])  | filte" :name="JSON.stringify(count[3].status)">
            </el-tab-pane>
            <el-tab-pane  :label="JSON.stringify(count[4]) | filte" :name="JSON.stringify(count[4].status)">
            </el-tab-pane>
            <el-tab-pane :label="JSON.stringify(count[7]) | filte"  :name="JSON.stringify(count[7].status)">
            </el-tab-pane>
            <el-tab-pane  :label="JSON.stringify(count[0]) | filte" :name="JSON.stringify(count[0].status)">
            </el-tab-pane>
            <el-tab-pane   :label="JSON.stringify(count[2])  | filte"  :name="JSON.stringify(count[2].status)">
            </el-tab-pane>
            <el-tab-pane  :label="JSON.stringify(count[1]) | filte" :name="JSON.stringify(count[1].status)">
            </el-tab-pane>
            <el-tab-pane   :label="JSON.stringify(count[5])  | filte" :name="JSON.stringify(count[5].status)">
            </el-tab-pane>
            <el-tab-pane   :label="JSON.stringify(count[6])  | filte" :name="JSON.stringify(count[6].status)">
            </el-tab-pane>
        </el-tabs>
         
                <el-form ref="form1" :model="form" label-width="120px" :inline="true">
                     <el-form-item label="下单时间" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
                    
               
                             <el-form-item >
                        <el-select v-model="form.key_type">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="出库单号" value="1"></el-option>
                            <el-option label="产品编号" value="2"></el-option>
                            <el-option label="产品名称" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                           <el-form-item label='支付方式'>
                        <el-select v-model="form.pay_type">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="线下支付" value="1"></el-option>
                            <el-option label="微信支付" value="2"></el-option>
                            <el-option label="微信扫码支付" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-input v-model="form.product_name" clearable readonly></el-input>
                    </el-form-item>
                    <el-form-item label="是否赠品:">
                        <el-select v-model="form.isgift">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="赠品" value="1"></el-option>
                            <el-option label="非赠品" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                        <el-form-item label="门店:">
                <el-col :span="12">
                    <el-input v-model="form.from_superior_sn" clearable></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 10px;">
                    <el-button type="primary" @click="selectType()">选择</el-button>
                </el-col>
            </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList(form)">搜索</el-button>
                        <el-button type="primary" @click="exportList(form)">导出</el-button>
                    </el-form-item>
                </el-form>
                <div style='margin-bottom:10px;'>订单总金额: <span class='red'>￥{{allMoney}} </span> </div>





                                   <div  style="width: 100%;margin-bottom: 20px; overflow:auto">
                <el-table
                  :data="tableData1"
                  style="width: 100%;margin-bottom: 20px"
                  border
                  fit
                  v-loading='loading'
                  max-height="500"
                  >
                  <el-table-column prop="id" label="序号" sortable fixed="left">
                    <template slot-scope="scope">
                      {{scope.row.id }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="stock_out_sn" label="订单号" fixed="left" width="180"></el-table-column>
                  <el-table-column prop="to_name" fixed="left" label="订货门店名称" width="180"></el-table-column>
                  <el-table-column prop="to_sn" label="订货门店编号"  width="180"></el-table-column>
                  <el-table-column prop="to_level_name" label="所属经销商编号" width="180"></el-table-column>
                  <el-table-column prop="from_superior_sn" width="180" label="所属经销商级别"></el-table-column>
                  <el-table-column prop="total_stock_out_num" width="180" label="订单金额">
                    <template slot-scope="scope">
                      {{scope.row.total_price | filMoney}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="total_stock_out_num" label="支付方式">
                    <template slot-scope="scope">
                      <span v-if="scope.row.pay_type == 1">线下支付</span>
                      <span v-if="scope.row.pay_type == 2">微信支付</span>
                      <span v-if="scope.row.pay_type == 3">微信扫码支付</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop label="是否赠品" width="180">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isgift == 1">赠品</span>
                      <span v-else>非赠品</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="to_address" label="收货地址"  width="180"></el-table-column>
                  <el-table-column prop="created_at" label="下单时间"  width="180"></el-table-column>
                  <el-table-column prop="order_notes" label="订单留言"  width="180"></el-table-column>
                  <el-table-column prop="product_sn" label="产品编号"  width="180"></el-table-column>
                  <el-table-column prop="product_name" label="产品名称" width="180">
                  </el-table-column>
                  <el-table-column prop="stock_out_num" label="下单数量" width="180">
                  </el-table-column>
                  <el-table-column prop="real_stock_out_num" label="实发数量">
                  </el-table-column>
                  <el-table-column prop="expiring_date" fixed="right"  label="状态">
                    <template slot-scope="scope">
                              <span v-if="scope.row.status == 0">未发货</span>
                              <span v-if="scope.row.status == 1">待收货</span>
                              <span v-if="scope.row.status == 2">发货中</span>
                              <span v-if="scope.row.status == 3">待付款</span>
                              <span v-if="scope.row.status == 4">待审核</span>
                              <span v-if="scope.row.status == 5">审核不通过</span>
                              <span v-if="scope.row.status == 6">已完成</span>
                              <span v-if="scope.row.status == 7">已取消</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="操作" fixed="right" width="180">
                    <template slot-scope="scope">
                        <!-- 0未发货 1已发货 2 部分发货 -->
                               <el-button type="text" size="small" @click='detail(scope.row)' v-if='scope.row.status!==4'>查看详情</el-button>
                                <el-button type="text" size="small"  @click='cancel(scope.row)' v-if='scope.row.status==0'>取消订单</el-button>
                                <el-button type="text" size="small"  @click='inAdvance(scope.row,0)' v-if='scope.row.status==1'>撤销结单</el-button>
                                <el-button type="text" size="small" @click='inAdvance(scope.row,1)' v-if='scope.row.status==2'>提前结单</el-button>
                                <el-button type="text" size="small" @click='review(scope.row,2)' v-if='scope.row.status==4'>审核订单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
        </div>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination>
            </el-tab-pane>
          </el-tabs>
      
                 <!--选择经销商-->
        <selectDealer
                v-if="selectDealerDialog"
                v-on:handleClose='selectDealerDialog = false'
                @pushData="getSelectinfo">
        </selectDealer>

     </div>
</template>


<script>
import selectDealer from '../../common/selectStore';
import handlerTable from '@/until/handlerTable'
export default {
    name:'myorder',
    data(){
        return{
              active:"1",
            showLink:false,
            selectDealerDialog:false,
             loading:false,
                activeName: ' ',
                form1:{
                    pay_type:'',
                    to_sn:'',
                    key_type:'',
                    keywords:'',
                    start_time:'',
                    end_time:'',
                    isgift:''
                },
                form:{
                    product_sn:'',
                    product_name:'',
                    pay_type:'',
                    role:'',
                    isgift:'',
                    custType:'',
                    start_time:'',
                    end_time:'',
                    from_superior_sn:""
                },
                tableData1: [
          
                ],
                tableData2: [

                ],
                is_parent:1,// 1 直属  2非直属
                status:  ' ',//订单状态
                //分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
                //分页
                pageNo: 1,//页码
                pageSize: 20,//每页现实的条数
                totalSize: 0,//总条数
                count:[],
                all:0,
                allMoney:0
                //    if (val.dealer_sn) {
                //         this.form.to_sn = val.dealer_sn;
                //         this.form.to_type = 2;

                //     } else {
                //         this.form.to_sn = val.shop_sn;
                //         this.form.to_type = 3;
                //     }
        }
    },
    methods:{
        //选择经销商
                selectType() {
                    this.selectDealerDialog = true;
                },
                  getSelectinfo(val) {
                    if (val.dealer_sn) {
                        if(this.active==1){
                             this.form1.to_sn = val.dealer_sn;
                           this.form1.to_type = 2;
                        }else{
                         this.form.from_superior_sn = val.dealer_sn;
                        this.form.to_type = 2;
                        }
                       

                    } else {
                            if(this.active==1){
                                 this.form1.to_sn = val.shop_sn;
                                this.form1.to_type = 3;
                        }else{
               this.form.from_superior_sn = val.shop_sn;
                        this.form.to_type = 3;
                        }
                  
                    }
                },
                // 获取直属订单列表
                getList(data){
                    
                    if(data){
                         var obj=data
                    }else{
                    
                      if(this.active==1){
                            var obj=this.form1
                        
                      }else{
                            var obj=this.form
                      }
                    }
                    
                    this.loading=true
                    this.tableData1=[]
                    if (obj.start_time) {
                        obj.start_time = this.moment(obj.start_time).format("YYYY-MM-DD");
                    }
                    if (obj.end_time) {
                        obj.end_time = this.moment(obj.end_time).format("YYYY-MM-DD");
                    }
                    this.$get('logistics','/shops.orders',{
                       is_parent:this.active,
                       status:this.status,
                       per_page:this.pageSize1,
                       page:this.pageNo1,
                        ...obj
                    }).then(res=>{
                        this.loading=false
                            this.pageNo1=res.meta.current_page
                            this.pageNo2=res.meta.current_page
                            this.totalSize1=res.meta.total
                            this.totalSize=res.meta.total
                            this.allMoney=res.total_price

                            //   res.data.forEach(element => {
                            //     this.allMoney+=parseInt(element.total_price)
                            // });
                             this.tableData1 = handlerTable(res.data,{
                                keys:'products'
                            })
                    }).catch(error=>{
                          this.$message({
                                type: 'error',
                                message: '请输入正确的信息'
                            });
                    })
                },
                handleSizeChange(val){
                    this.pageSize=val
                    this.getList(this.form1)
                },
                handleCurrentChange(val){
                    this.pageNo=val
                    this.getList(this.form1)

                },
                    handleSizeChange1(val){
                    this.pageSize1=val
                    this.getList(this.form)
                },
                handleCurrentChange1(val){
                    this.pageNo1=val
                    this.getList(this.form)
                },
                handleIsparent(){
                if(this.active==1){
                    this.getList(this.form1)
                }else{
                    this.getList(this.form)
                }
                    this.getCount()

                },
                handleClick(val){
                    this.getList(this.form1)
           
                },
                exportList(){
                // localStorage.setItem('access_tokens','eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg2MWFkZTk2OGZhM2RlODFhZmY4ZGY1MTBhNGZiZmM2ZDE4ZDE5NjU2ZWRkNWYyNDAyN2JiNjQ4ZjAxYTg4OTI4MTNkMzI1OTBjODUzOTMyIn0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6Ijg2MWFkZTk2OGZhM2RlODFhZmY4ZGY1MTBhNGZiZmM2ZDE4ZDE5NjU2ZWRkNWYyNDAyN2JiNjQ4ZjAxYTg4OTI4MTNkMzI1OTBjODUzOTMyIiwiaWF0IjoxNTYyNzU5MjczLCJuYmYiOjE1NjI3NTkyNzMsImV4cCI6MTU2NDA1NTI3Mywic3ViIjoiMjIiLCJzY29wZXMiOlsiKiJdfQ.NsIp_fAqXcOn4osyLQ6fTxVTiqUt2ah9LL30AJnWoBdmDTOerX5myrW75Vtkz1obu8XhwA2zKzz1Toy1jDfeWC0DmpK7R6LvqeumckjombxVK979uCQHu3l0InUJ25_IiD99Br9oSNEIV2zIUGaQsCmxqCmOzgEwn8AYX2PyQamcZLFhew-F-aOUDYvHWoduXV401gtCOAEDZR5LbJsLSZJ00rp06qg-QkXiQYwYRQ90rRJXyL3BHII1Bl9bmzLRZ_LD_EHA_BLN_6ZSdAuzqLHh5UK6P2Q1UNkM0YH8LOIiMpVneWjlpkhI55GBZfTTPkCu5HLE7GXx4bjZk5En99vtLUYR8ACcaJeY4a1LjH8SCvaDKcj3eVk8OpPD4-P3qzT6rmyOceymCxzqVMXknZO0PN3yjEg9-KJiHCIQIXJ3Qy_rR1eq5gxLhYmYmkKNxwS8HEcttyezj1M93YG3ewB0cAJA9O9DL2RwY2jhTnQel3UAzG0vjnEK_oH-SctRse38pMt6F_yyDa2EO22utHrysCSI7rRVA9xADFUth2C333cPsmZ2dmKxup_hZGlncINxjs8hUQQ_jWDmNrELe2fm9_n13uvVVeIYmeqs4H9l7Z2uZxWZOr7kNYF3FUTa37hp2LiOt8hCvuCc9qDbE8ur-Ed9BbR5rzTZltgGIo4')
                let beginstr = "",
                endstr = "";
            var page='' ,per_page='',obj={}
            if(this.active==1){
                obj=this.form1
               page=this.pageNo1
               per_page=this.pageSize1
            }else{
                obj=this.form
                page=this.pageNo2
               per_page=this.pageSize2
            }
            if (obj.start_time) {
                beginstr = this.moment(obj.start_time).format("YYYY-MM-DD");
            }
            if (obj.end_time) {
                endstr = this.moment(obj.end_time).format("YYYY-MM-DD");
            }
            let url = "",
                access_tokens = localStorage.getItem("access_tokens");
           
            if(this.active==1){
                  window.open(
        this.$Base_Export+
            "/shops.orders.export?start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&is_export="+
            1+
            '&is_parent='+
            +this.active+
            "&status="+
            +this.status+
            "&keywords=" +
            obj.keywords +
            "&key_type=" +
            obj.key_type +
            "&lang=" +
            "" +
 
            "&to_sn=" +
            obj.to_sn +
            "&pay_type=" +
            obj.pay_type +
            "&isgift=" +
            obj.isgift +
            "&signature=" +
            this.$md5(access_tokens)
        );
            }else{
  window.open(
        url +
            process.env.VUE_APP_URL +
            "/shops.orders.export?start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&is_export="+
            1+
            '&is_parent='+
            +this.active+
            "&status="+
            +this.status+
            "&keywords=" +
            obj.keywords +
            "&key_type=" +
            obj.key_type +
            "&lang=" +
            "" +
         
            "&from_superior_sn=" +
            obj.from_superior_sn+

            "&pay_type=" +
            obj.pay_type +

            "&signature=" +
            this.$md5(access_tokens)
        );
            }
    
                },
        // 取消订单
        cancel(data){
              this.$confirm("是否取消订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(()=>{
           var url='/shops.orders/'+data.stock_out_sn?data.stock_out_sn:data.row_sn+'/cancel'
            this.$patch('logistics',url,{
                _method:'PATCH'
            }).then(res=>{
                 this.$message({
                                type: 'success',
                                message: '成功'
                            });
                            if(this.active==1){
                                this.getList(this.form1)
                            }else{
                                this.getList(this.form)

                            }
            }).catch(error=>{
                 this.$message({
                                type: 'error',
                                message: '取消失败'
                            });
            })
      })
           
        },
        // 获取不同状态的 数量
          getCount(){
            this.$get('logistics','/shops.orders.count',{
                is_parent:this.active
            }).then(res=>{
                // count
                            // 
                            var temp=0
                res.data.forEach(element => {
                        temp+=Number(element.total)
                });
                this.all='全部('+temp+')'
                this.count=res.data
            })
        },
        // 提前结单
        inAdvance(data,status){
            // /dealers.orders/{order}
                    this.$confirm(status==0?"是否撤销订单?":'"是否提前订单?"', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(()=>{
            var url='/shops.orders/'+data.stock_out_sn?data.stock_out_sn:data.row_sn
            this.$patch('logistics',url,{
                _method:'PATCH',
                advance_order_status :status
            }).then(res=>{
                 this.$message({
                                type: 'success',
                                message: '成功'
                            });
                            if(this.active==1){
                                this.getList(this.form1)
                            }else{
                                this.getList(this.form)

                            }
            }).catch(error=>{
                 this.$message({
                                type: 'error',
                                message: '取消失败'
                            });
            })
      })
        },
        // 查看详情
        detail(data){
        
            this.$router.push({
                name:'storeOrderDetail',
                query:{id:data.stock_out_sn?data.stock_out_sn:data.row_sn}
            })
        },
          // 查看审核
        review(data,temp){
            this.$router.push({
                name:'storeOrderReview',
                query:{id:data.stock_out_sn?data.stock_out_sn:data.row_sn,is_parent:temp}
            })
        }
    },
    filters: {
  filte: function (value) {
      var  str=' '
  
        value=JSON.parse(value)

      switch(value.status){
        case 0:
        str='未发货('+value.total+')'

        break;
         case 1:
        str='待收货('+value.total+')'

        break;
         case 2:
        str='发货中('+value.total+')'
        break;
         case 3:
          
        str='待付款('+value.total+')'
        break;
         case 4:
        str='待审核('+value.total+')'
        break;
         case 5:
        str='审核不通过('+value.total+')'
        break;
         case 6:
        str='已完成('+value.total+')'

        break;
        case 7:
        str='已取消('+value.total+')'
        break;
      }
    return str
  }
},
    created(){
        this.getList(this.form1)
        this.getCount()
    },
     components: {
            selectDealer
        }
}
</script>

<style lang="scss" scoped>
    .tableBox {
        overflow-x: scroll;
        .table {
            width: 300%;
        }
    }
.red{
    color: #f04635;
}
</style>